/* eslint-disable react/jsx-key */
/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useState, useEffect } from 'react'
import { ShimmerBadge,
    ShimmerButton,
    ShimmerTitle,ShimmerThumbnail,ShimmerSectionHeader, ShimmerCircularImage, ShimmerText } from 'react-shimmer-effects'
import ViewAllRolesShimmer from './ViewAllRolesShimmer'

export default function ViewStaffShimmer() {
    return (

        <div className=" opacity-100 transition-opacity duration-150 ease-linear data-[te-tab-active]:block px-[30px]" id="tabs-institutionDetails" role="tabpanel" aria-labelledby="tabs-institutionDetails-tab">
            <div className=" w-[80%] mx-auto">
                <div className="w-full border border-[#D0D5DD] rounded p-3 mb-4">
                    <div className="flex mb-1">
                        <div className="w-1/2">
                            <div className="w-full">
                                <p className="text-2xl font-bold text-[#031624] mt-1"><ShimmerTitle line={1} gap={10} variant="secondary" className="w-[150px]" /></p>
                                <p className="text-2xl font-bold text-[#031624] mt-1"><ShimmerTitle line={1} gap={10} variant="secondary" className="w-[180px]" /></p>
                                <p className="text-2xl font-bold text-[#031624] mt-1"><ShimmerTitle line={1} gap={10} variant="secondary" className="w-[180px]" /></p>
                            </div>
                        </div>
                        <div className="w-1/2 ml-4">
                            <div className="w-full">
                                <p className="text-2xl font-bold text-[#031624] mt-1"><ShimmerTitle line={1} gap={10} variant="secondary" className="w-[150px]" /></p>
                                <p className="text-2xl font-bold text-[#031624] mt-1"><ShimmerTitle line={1} gap={10} variant="secondary" className="w-[180px]" /></p>
                                <p className="text-2xl font-bold text-[#031624] mt-1"><ShimmerTitle line={1} gap={10} variant="secondary" className="w-[180px]" /></p>
                                <p className="text-2xl font-bold text-[#031624] mt-1"><ShimmerTitle line={1} gap={10} variant="secondary" className="w-[180px]" /></p>
                            </div>
                            <hr></hr>
                            <p className="text-2xl font-bold text-[#031624] mt-1"><ShimmerTitle line={1} gap={10} variant="secondary" className="w-[180px]" /></p>
                            <p className="text-2xl font-bold text-[#031624] mt-1"><ShimmerTitle line={1} gap={10} variant="secondary" className="w-[180px]" /></p>
                        </div>
                    </div>
                </div>
            </div>
            <ViewAllRolesShimmer />
        </div>
    )
}
